import { useEffect, useState } from 'react';

// Tooltip padrão do sistema (T-034b): substitui o title nativo do navegador
// (caixa sem formatação) em TODO o app. Uso: data-dica="linha 1|linha 2|…"
// no elemento — a 1ª linha sai em negrito branco, a 2ª em negrito âmbar
// (destaque), as demais em seminegrito. Um único listener por delegação.

interface Dica {
  x: number;
  y: number;
  linhas: string[];
}

export function DicaGlobal() {
  const [dica, setDica] = useState<Dica | null>(null);

  useEffect(() => {
    const mover = (e: MouseEvent) => {
      const alvo = (e.target as HTMLElement | null)?.closest?.('[data-dica]');
      const texto = alvo?.getAttribute('data-dica') ?? '';
      if (texto === '') {
        setDica((atual) => (atual === null ? atual : null));
        return;
      }
      setDica({ x: e.clientX, y: e.clientY, linhas: texto.split('|') });
    };
    const esconder = () => setDica(null);
    window.addEventListener('mousemove', mover, { passive: true });
    window.addEventListener('scroll', esconder, { passive: true, capture: true });
    return () => {
      window.removeEventListener('mousemove', mover);
      window.removeEventListener('scroll', esconder, { capture: true });
    };
  }, []);

  if (dica === null) return null;
  return (
    <div
      className="pointer-events-none fixed z-[60] max-w-sm rounded-md bg-gray-900 px-3 py-2 text-xs leading-relaxed text-white shadow-xl"
      style={{
        left: Math.min(dica.x + 14, window.innerWidth - 340),
        top: Math.min(dica.y + 16, window.innerHeight - 90),
      }}
    >
      {dica.linhas.map((linha, i) => (
        <p
          key={i}
          className={
            i === 0
              ? 'font-bold'
              : i === 1
                ? 'font-bold text-amber-300'
                : 'font-semibold text-white/85'
          }
        >
          {linha}
        </p>
      ))}
    </div>
  );
}
